import React from "react";
import { FolderOpen, Trash2 } from "lucide-react";
import type { GeneratedSlides } from "../types";

interface SavedStepProps {
  savedPresentations: GeneratedSlides[];
  onLoadPresentation: (pres: GeneratedSlides) => void;
  onDeletePresentation: (id: string) => void;
  onBack: () => void;
}

export const SavedStep: React.FC<SavedStepProps> = ({
  savedPresentations,
  onLoadPresentation,
  onDeletePresentation,
  onBack,
}) => {
  return (
    <div className="p-6">
      <div className="flex justify-between mb-6">
        <h3 className="text-xl font-bold">Apresentações Salvas</h3>
        <button onClick={onBack} className="text-blue-600">
          ← Voltar
        </button>
      </div>
      {savedPresentations.length === 0 ? (
        <div className="text-center py-12">
          <FolderOpen className="w-16 h-16 mx-auto text-gray-300 mb-4" />
          <p className="text-gray-500">Nenhuma apresentação salva</p>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {savedPresentations.map((pres) => (
            <div key={pres.id} className="p-4 border rounded-lg">
              <h4 className="font-bold mb-2">{pres.title}</h4>
              <p className="text-sm text-gray-600 mb-3">
                {pres.slideCount} slides
              </p>
              <div className="flex gap-2">
                <button
                  onClick={() => onLoadPresentation(pres)}
                  className="flex-1 px-3 py-2 bg-blue-50 text-blue-700 rounded-lg text-sm"
                >
                  Abrir
                </button>
                <button
                  onClick={() => onDeletePresentation(pres.id)}
                  className="px-3 py-2 bg-red-50 text-red-700 rounded-lg"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
